import request from '../../utils/requests'
/** * Tag: Holiday */
const baseUrl ="/api/Holiday";

/** * 新增假期设置 * @param {*} body * { *    BranchId Desc:校区id 机构端设置可不填 Required:false *    Name Desc:假期姓名 Required:true *    Date Desc:假期时间 yyyy-MM-dd Required:true * } */async function _add(body) {  return request(baseUrl+'/add',{    method: 'POST',    body: body,  });
}

/** * 删除假期 * @param {*} param * { *    holidayid Desc: Required:true * } */async function _del(param) {  return request(baseUrl+'/del',{    method: 'GET',    params: param,  });
}

/** * 获取具体年份的假期 * @param {*} param * { *    year Desc:yyyy Required:true *    branchid Desc:为空，返回的是机构假期 Required:true * } */async function _getYearHoliday(param) {  return request(baseUrl+'/getYearHoliday',{    method: 'GET',    params: param,  });
}

export default{  _add,  _del,  _getYearHoliday}



// WEBPACK FOOTER //
// ./src/services/holiday.js